import { supabase } from '../../../lib/supabase';

type StripeBillingAction =
  | 'create_customer'
  | 'get_customer'
  | 'attach_payment_method'
  | 'update_customer_default_payment_method'
  | 'create_subscription'
  | 'create_checkout_session'
  | 'cancel_subscription'
  | 'create_payment_intent'
  | 'create_setup_intent'
  | 'get_subscription'
  | 'list_subscription_products';

export async function invokeStripeBilling<T>(action: StripeBillingAction, payload: Record<string, unknown> = {}): Promise<T> {
  const { data, error } = await supabase.functions.invoke('stripe-billing', {
    body: {
      action,
      ...payload,
    },
  });

  if (error) {
    throw new Error(error.message || 'Stripe billing function failed');
  }

  if (data?.error) {
    throw new Error(data.error);
  }

  return data as T;
}
